import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Alumni = () => {
  const partners = [
    { name: 'Air Arabia', image: 'https://rsa.demotestingurl.xyz/wp-content/uploads/2025/12/airarabia.png' },
    { name: 'Air Express', image: 'https://rsa.demotestingurl.xyz/wp-content/uploads/2025/12/Air-express.png' },
    { name: 'SpiceJet', image: 'https://rsa.demotestingurl.xyz/wp-content/uploads/2025/12/Spicejet.png' },
    { name: 'Jet Airways', image: 'https://rsa.demotestingurl.xyz/wp-content/uploads/2025/12/jetairways.png' },
    { name: 'Vietnam Airways', image: 'https://rsa.demotestingurl.xyz/wp-content/uploads/2025/12/Vietnam-airwyas.png' },
    { name: 'Qatar Airways', image: 'https://rsa.demotestingurl.xyz/wp-content/uploads/2025/12/Qatarairways.png' },
  ];

  return (
    <section className="py-5 alumni">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Our Alumni</h2>
        </div>
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 2000 }}
          pagination={{ clickable: true }}
          navigation={true}
          slidesPerView={2}
          breakpoints={{
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
          className="alumni-slider"
        >
          {partners.map((partner, index) => (
            <SwiperSlide key={index}>
              <div className="text-center">
                <img src={partner.image} alt={partner.name} className="img-fluid" style={{maxHeight: '200px', objectFit: 'contain'}} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Alumni;